class GROW_Navigation {

	constructor() { 
		this.siteLanguage = document.documentElement.lang.split('-')[0]
		this.backText = this.siteLanguage === 'de' ? '« Zurück' : '« Back'
	}

	toggleLanguageSwitcher() { 
		const languageSwitcher = document.querySelector('.grow__language--switcher')
		const languageSwitcherButton = document.querySelector('.grow__language--switcher > svg')

		languageSwitcherButton.addEventListener('click', () => {
			languageSwitcher.classList.toggle('active')
		})
	}

	toggleStickyNav(el) {
		el.classList.toggle('active')
	 }

	toggleMenuClass(elements, info) {
		elements.forEach((element) => {
			element.addEventListener('click', (e) => {
				e.preventDefault()
				console.log(info)
				if (element.parentNode.classList.contains('active')) {
					element.parentNode.classList.remove('active')
					element.parentNode.parentNode.classList.remove('slided')
				} else { 
					elements.forEach((el) => {
						el.parentNode.classList.remove('active')
					})
					element.parentNode.classList.add('active')
					element.parentNode.parentNode.classList.add('slided')
				}
			})		
		 })
	}

	removeMenuClass(elements, info) {
		elements.forEach((element) => {
			element.parentNode.classList.remove('active')
			element.parentNode.parentNode.classList.remove('slided')
			elements.forEach((el) => {
				el.parentNode.classList.remove('active')
			})
		 })
	}
	
	addBackLinkMobile() { 
		const subMenuElements = document.querySelectorAll('.main__menu_list .menu-item-has-children .sub-menu')
		subMenuElements.forEach(el => { 
			const backLink = document.createElement('li')
			backLink.classList.add('back')
			backLink.onclick = () => {
				el.parentNode.classList.remove('active')
				el.parentNode.parentNode.classList.remove('slided')
			}
			backLink.innerHTML = `<a href="#">${this.backText}</a>`
			if(!el.parentNode.querySelector('[title="social__media"]')) el.prepend(backLink)
		})

	}

	setNavOffset() { 
		const offsetElements = document.querySelectorAll('[data-header-offset]')
		const headerHeight = document.querySelector('.main__nav--fixed').offsetHeight
		offsetElements.forEach(el => {
			el.style.marginTop = headerHeight + 'px'
		}
		)
	}

	toggleSubMenu() { 
		const subMenuElements = document.querySelectorAll('.main__menu_list > .menu-item-has-children > a')
		const subSubMenuelements = document.querySelectorAll('.main__menu_list .menu-item-has-children .menu-item-has-children > a')
		this.toggleMenuClass(subMenuElements, 'Main')
		this.toggleMenuClass(subSubMenuelements, 'sub')
	}

	toggleNavBg() { 
		window.addEventListener('scroll', () => {
			const mainNavFixed = document.querySelector('.main__nav--fixed')		
			if (window.scrollY >= 50) {
				mainNavFixed.classList.add('solid')
			} else {
				mainNavFixed.classList.remove('solid')
			}
		})
	}

	closeSubMenu() { 
		const subMenuElements = document.querySelectorAll('.main__menu_list > .menu-item-has-children > a')
		const subSubMenuelements = document.querySelectorAll('.main__menu_list .menu-item-has-children .menu-item-has-children > a')
		this.removeMenuClass(subMenuElements, 'Main')
		this.removeMenuClass(subSubMenuelements, 'sub')
	}

	toggleMobileNav() { 
		const mainNav = document.querySelector('.main__nav-top')
		const mobileNavButton = document.querySelector('.main__nav-burger')

		mobileNavButton.addEventListener('click', () => {
			mainNav.classList.toggle('active')
			mobileNavButton.classList.toggle('active')
		})
	}

	showContactModal() {
		document.body.append(grow_contact_modal.content.cloneNode(true))
		const modal = document.querySelector('.grow__modal')
		const modalLinks = document.querySelectorAll('.grow__modal a')
		modalLinks.forEach(el => {
			el.addEventListener('click', () => {
				modal.remove()
			})
		})

	}
	closeContactModal(el) { 
		el.closest('.grow__modal').remove()
	}
}

const growNavigation = new GROW_Navigation();

window.addEventListener('DOMContentLoaded', () => {
	if (document.querySelector('.grow__language--switcher')) {
		growNavigation.toggleLanguageSwitcher()		
	}
	growNavigation.toggleSubMenu()
	growNavigation.toggleMobileNav()
	growNavigation.toggleNavBg()
	growNavigation.addBackLinkMobile()
	growNavigation.setNavOffset()
	// const navBurger = document.querySelector('.main__nav-dots')
	// const flyoutNav = document.querySelector('.main__nav-flyout')
	const navItems = document.querySelectorAll('.main__menu_list li a')

	document.addEventListener('click', e => { 
		const isNav = e.target.closest('.main__nav--fixed')
		if(!isNav) growNavigation.closeSubMenu()
	})

	document.addEventListener('keyup', e => { 
		const isEscape = e.key === 'Escape'
		if(isEscape) growNavigation.closeSubMenu()
	})

	const mainNavFixed = document.querySelector('.main__nav--fixed')
	
	const toggleMenu = () => {
		// flyoutNav.classList.toggle('active')
		// navBurger.classList.toggle('active')
	}
	
	const closeMenu = () => {
		// flyoutNav.classList.remove('active')
		// navBurger.classList.remove('active')	
	}


	
	// navBurger?.addEventListener('click', toggleMenu)
	navItems.forEach(navItem => {
		navItem.addEventListener('click', closeMenu)
	})

	document.body.addEventListener('keyup', e => {
		closeMenu()
	})
})

window.addEventListener('resize', () => {
	growNavigation.setNavOffset()
}
)

